module.exports = __webpack_public_path__ + "static/media/donna.75c68a03.png";